<avn-donut
  [style.width.px]="heightInPx"
  [style.height.px]="heightInPx"
  [showDataLabels]="false"
  [data]="pieDataItems$ | async"
  [datumShownInChartCenter]="displayedPieDatum$ | async"
></avn-donut>

